import React from "react";
import { NumericFormat } from "react-number-format";
import { Box, Typography } from "@mui/material";
import { unitCode } from "../../../../common/models/CommonModels";
import { classNames, dimensions } from "../../../../shared/models/models";
import DataBlock from "../../../../shared/components/dataBlocks/DataBlock";
import DataBlocks from "../../../../shared/components/dataBlocks/DataBlocks";
import { AdminStockItem } from "../../../models/AdminStockItemsModels";
import StockItemDetailsAvailability from "../../../../customer/inventory/components/StockItemDetailsAvailability";
import { ProductAvailabilityCode } from "../../../../customer/inventory/models/models";
import ImageBox from "../../../../shared/components/ImageBox";
import useTranslation from "../../../../shared/hooks/useTranslation";

interface MainProps {
  stockItem: AdminStockItem | undefined;
  className: string;
}

const Main = ({ stockItem, className }: MainProps) => {
  const { translate } = useTranslation("common");
  return (
    <Box className={classNames("", className)}>
      <Box>
        <StockItemDetailsAvailability
          availabilityCode={stockItem?.availabilityCode || ProductAvailabilityCode.inStock}
        />
      </Box>

      <Box className="flex justify-between mt-4 gap-4">
        <Typography fontSize={14} fontWeight={500} className="text-14-medium uppercase" style={{ color: "#333" }}>
          {stockItem?.product.manufacturer.name}
        </Typography>

        <Typography fontSize={12} fontWeight={600} className="text-12-bold text-right">
          {stockItem?.product.category?.name}
        </Typography>
      </Box>

      <Box className="flex w-full justify-between mt-4 gap-4">
        <Box className="flex items-end">
          <Typography fontSize={20} fontWeight={600} className="text-20-bold">
            <NumericFormat value={stockItem?.price?.value} displayType="text" thousandSeparator=" " suffix="€" />
          </Typography>
        </Box>

        <Box>
          <ImageBox size="medium" src={stockItem?.file?.content} />
        </Box>
      </Box>

      <DataBlock className="text-12-medium mt-4" title="Description" value={stockItem?.description} />

      <DataBlocks className="mt-4">
        <DataBlock variant="inline" title="Weight, kg" value={stockItem?.weight} />
        <DataBlock
          variant="inline"
          title="Dimensions, mm"
          value={dimensions(stockItem?.height, stockItem?.width, stockItem?.depth)}
        />
        <DataBlock
          variant="inline"
          title="Available"
          value={stockItem?.availabilityCode === ProductAvailabilityCode.inStock ?
            `${stockItem?.quantity?.value} ${translate(`measurementUnits.${unitCode(stockItem.quantity?.unitCode)}`)}` : "0"
          }
        />
      </DataBlocks>
    </Box>
  );
};

export default Main;
